import React from 'react';
import PropTypes from 'prop-types';
import './LoadingOverlay.css';

const LoadingOverlay = ({ message, status }) => {
  return (
    <div className="loading-overlay">
      <div className="loading-content">
        <div className="loading-spinner"></div>
        <div className="loading-message">{message || 'Loading...'}</div>
        {status && <div className="loading-status">{status}</div>}
      </div>
    </div>
  );
};

LoadingOverlay.propTypes = {
  message: PropTypes.string,
  status: PropTypes.string,
};

LoadingOverlay.defaultProps = {
  message: 'Loading...',
};

export default LoadingOverlay;
